import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import app from './firebase';

// Re-exports from the single Firebase instance.
// DO NOT call initializeApp() here; firebase.ts owns the default app.
export { auth, default } from './firebase';

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
